<template>
    <div id="shareCloud">
        <span id="scTitle" v-text="sCText"></span>
        <div id="scTable">
            <ul id="scTh" class="cle">
                <li :class="[items.class,'fl']" v-show="index!==2" v-for="(items,index) in title" :key="index" v-text="items.text" :title="items.text"></li>
            </ul>
            <ul v-for="(item,index) in setList" :key="index" class="cle">
                <li :class="[title[0].class,'fl']" v-text="item.name" :title="item.name"></li>
                <li :class="[title[1].class,'fl']" v-text="item.cloudId" :title="item.cloudId"></li>
                <li :class="[title[2].class,'fl']" v-show="false" v-text="item.ip" :title="item.ip"></li>
                <li :class="[title[3].class,'fl']" v-text="item.account===''?'':item.account===item.nikeName?item.nikeName:item.nikeName" :title="item.account===''?'':item.account===item.nikeName?item.nikeName:item.nikeName"></li>
                <li :class="[title[4].class,'fl']" v-text="item.time" :title="item.time"></li>
                <li :class="[title[5].class,'fl']" v-text="item.power" :title="item.power"></li>
                <li :class="[title[6].class,'fl']">
                    <img v-if="item.cloudId!==''" :src="item.online?Online:Downline" style="width:18px;height:18px;margin-top:3px;">
                </li>
                <li :class="[title[7].class,'fl']">
                    <img v-if="item.access" :src="Access" @click="access($event,item.cloudId,item.name,item.pwd,item.isHs)" style="width:18px;height:18px;margin-top:3px;cursor:pointer;">
                </li>
                <li :class="[title[8].class,'fl']">
                    <img v-if="item.change" :src="Change" @click="change($event,item.cloudId,item.name,item.pwd,item.isHs,item.channel)" style="width:18px;height:18px;margin-top:3px;cursor:pointer;">
                </li>
                <li :class="[title[9].class,'fl']" v-text="shareStatus[item.status]" :title="shareStatus[item.status]"></li>
            </ul>
        </div>
        <div style="width:100%;height:30px;" class="cle">
          <Page :nowPage="nowPage" :allPage="allPage" :showNum="showNum" v-on:getPage="getPage" class="fr"></Page>
      </div>
    </div>
</template>
<script>
import Page from './Page'
export default {
    name:'ShareDevice',
    props:['shareDevice','ocx'],
    components:{
        Page:Page
    },
    data(){
        return{
            sCText:'',
            title:[
                {text:'',class:'title-2'},
                {text:'',class:'title-3'},
                {text:'',class:'title-3'},
                {text:'',class:'title-2'},
                {text:'',class:'title-4'},
                {text:'',class:'title-4'},
                {text:'',class:'title-1'},
                {text:'',class:'title-1'},
                {text:'',class:'title-1'},
                {text:'',class:'title-1'}
            ],
            setList:[],
            Change: './static/img/change.png',
            Access: './static/img/access.png',
            Online:'./static/img/online.png',
            Downline:'./static/img/downline.png',
            nowPage:1,
            allPage:1,
            showNum:10,
            wkAs:{
                'id':'',
                'name':'',
                'pwd':''
            },
            pro:'http',
            isHs:0,
            pwd:'',
            IPPort:'',
            contP:'',
            shareStatus:[
                this.lanNow.lan['K196_Stay'],
                this.lanNow.lan['K181_Share'],
                this.lanNow.lan['K195_Ignored']
            ],
            listinit:[]
        }
    },
    mounted:function(){
        this.lang();
        this.listinit=[];
        for(var i=0;i<10;i++){
            this.listinit.push({
                deviceId:'',
                cloudId:'',
                ip:'',
                name:'',
                nikeName:'',
                account:'',
                change:false,
                access:false,
                pwd:'',
                time:''
            });
        };
        this.setList=this.listinit;
    },
    methods:{
        getList:function(){
            var arr=JSON.parse(JSON.stringify(this.shareDevice));
            
            var arrZ=[];
            for(var i=0;i<arr.length;i++){
                for(var j=0;j<arr[i].length;j++){
                    if(arr[i][j].id!==''){
                        arrZ.push(arr[i][j],arr[i][j],arr[i][j],arr[i][j],arr[i][j]);
                    };
                };
            };
            var arrZs=arrZ.concat([]);
            var cont=[];
            for(var i=0;i<arrZs.length;i++){
                cont.push(arrZs.splice(0,10));
                i=0;
            };
            arr=cont.concat([]);

            var len=arr.length;
            if(len===0){
                var arrs=[];
                for(var i=0;i<10;i++){
                    arrs.push({
                        deviceId:'',
                        cloudId:'',
                        ip:'',
                        name:'',
                        nikeName:'',
                        account:'',
                        change:false,
                        access:false,
                        pwd:'',
                        time:''
                    });
                };
                arr.push(arrs);
            }else{
                var lens=10-arr[len-1].length;
                for(var i=0;i<lens;i++){
                    arr[len-1].push({
                        deviceId:'',
                        cloudId:'',
                        ip:'',
                        name:'',
                        nikeName:'',
                        account:'',
                        change:false,
                        access:false,
                        pwd:'',
                        time:''
                    });
                };
            };
            if(this.nowPage>arr.length&&arr.length>=1){
                this.setList=arr[arr.length-1];
                this.nowPage=arr.length;
            }else{
                this.setList=arr[this.nowPage-1];
            };
            this.allPage=arr.length;
        },
        change:function(_that,id,name,pwd,isHs,channel){
            this.isHs=isHs;
            if(id===''){
                return false;
            };
            this.$emit("editBom",{ele:_that,id:id,name:name,isChange:false,upo:pwd,num:channel,isHs:isHs});
        },
        access:function(_that,id,name,pwd,isHs){
            this.isHs=isHs;
            this.pwd=pwd;
            if(id===''){
                return false;
            };
            this.$emit("loadMsg",true);
            // this.$nextTick(function(){
                if(this.browserDetect() !== 'IE')
                {
                    this.wkAs.id = id;
                    this.wkAs.name = name;
                    this.wkAs.pwd = pwd;
                    if(this.socket.set.readyState===1){
                        this.pro='http://';
                        this.socketObj.set[116]=function(res){
                            if(this.isHs){
                                this.cf_ShareDeviceP2PHs(res[0]);
                            }else{
                                this.cf_ShareDeviceP2P(res[0]);
                            };
                        }.bind(this);
                        if(this.isHs){
                            this.socket.set.send(this.jsonStr(116,[id,2,'0']));//非IE浏览器端口穿透华视云
                        }else{
                            this.socket.set.send(this.jsonStr(116,[id,2,'1']));//非IE浏览器端口穿透
                        };
                    }else{
                        this.$emit("loadMsg",false);
                    };
                    return false;
                }
                try {
                    var test=this.ocx.IGetSupportP2P()-0;
                    if(test===0){
                        this.$emit("loadMsg",false);
                        if(confirm(this.lanNow.lan['K160_NoSupport'])){
                            window.open(this.baseData['Plug-in']);
                        };
                        return false;
                    };
                } catch (error) {
                    this.$emit("loadMsg",false);
                    if(confirm(this.lanNow.lan['K149_plugIn'])){
                        window.open(this.baseData['Plug-in']);
                    };
                    return false;
                };
                //   1.    IGetSupportP2P()，返回值为1表示插件支持IOT穿透功能
                //   2.    ICloudAddMapPortEx("云ID"， chn) : chn == 0,表示穿透34567，用于预览 ；chn == 2，表示穿透80,用于跳转到登录网页
                if(this.isHs){
                    this.pwd=JSON.parse(this.pwd);
                };
                setTimeout(function(){
                    var ocx=this.ocx;
                    if(this.isHs){
                        this.pro='http://';
                        var po=ocx.ICloudAddMapPort(id, 2, 0)-0;
                        if (po <= 0){
                            this.$emit("loadMsg",false);
                            alert(this.lanNow.lan['K174_Fail']);
                            this.$emit('refresh');
                            return false;
                        };
                        var content = '<?xml version="1.0" encoding="utf-8"?>' +
                            '<envelope>' +
                            '<header>' +
                            '<security>username</security>' +
                            '<username>' +this.pwd.user+ '</username>' +
                            '<password>' +this.pwd.pwd+ '</password>' +
                            '</header>' +
                            '<body>' +
                            '<command>get.system.login</command>' +
                            '<content></content>' +
                            '</body>' +
                            '</envelope>';
                        var states = ocx.IGetCGI("http://127.0.0.1:" + po + "/tdkcgi", content);
                        if (states === 'error'){
                            var status = ocx.IGetCGI("https://127.0.0.1:" + po + "/tdkcgi", content);
                            if(status === 'error'){
                                var pos=ocx.ICloudAddMapPort(id, 1, 0)-0;
                                if(pos>0){
                                    window.open('./webClient.html?'+id+'&'+this.pwd.user+'&'+this.pwd.pwd+'&'+localStorage.getItem('lan'));
                                    this.$emit("loadMsg",false);
                                    return false;
                                };
                                this.$emit("loadMsg",false);
                                alert(this.lanNow.lan['K174_Fail']);
                                return false;
                            }else {
                                this.pro = 'https';
                            };
                        };
                        this.$emit("loadMsg",false);
                        var deviceUserName=this.pwd.user;
                        var baseFun=this.base64;
                        var base=new baseFun();
                        var user=base.encode(deviceUserName);
                        var pw=base.encode(this.pwd.pwd);
                        var url = this.pro+"127.0.0.1:" + po + "/main.html" + "?" + po + "&" + id +
                            "&" + user + "&" + pw + "&" + localStorage.getItem('lan')+'&'+name;
                        window.open(url);
                        return false;
                    };
                    if(ocx.IGetSupportP2P()-0){
                        this.pro='http://';
                        var port=ocx.ICloudAddMapPortEx(id,2);
                        if(port-0===0){
                            port=ocx.ICloudAddMapPortEx(id,1);
                            this.pro='https://';
                        }else{
                            var content = '<?xml version="1.0" encoding="utf-8"?>' +
                                '<envelope>' +
                                '<header>' +
                                '<security>username</security>' +
                                '<username>adminapp</username>' +
                                '<password>' +this.pwd+ '</password>' +
                                '</header>' +
                                '<body>' +
                                '<command>get.system.login</command>' +
                                '<content></content>' +
                                '</body>' +
                                '</envelope>';
                            var states = ocx.IGetCGI("http://127.0.0.1:" + port + "/tdkcgi", content);
                            if (states === 'error'){
                                port=ocx.ICloudAddMapPortEx(id,1);
                                this.pro='https://';
                            };
                        };
                        this.$emit("loadMsg",false);
                        if(port-0===0){
                            alert(this.lanNow.lan['K174_Fail']);
                            this.$emit('refresh');
                        }else{
                            var deviceUserName='adminapp';
                            var baseFun=this.base64;
                            var base=new baseFun();
                            var user=base.encode(deviceUserName);
                            var pwd=base.encode(this.pwd);
                            var url = this.pro+"127.0.0.1:" + port + "/main.html" + "?" + port + "&" + id +
                                "&" + user + "&" + pwd + "&" + localStorage.getItem('lan')+'&'+name;
                            window.open(url);
                        };
                    }else{
                        this.$emit("loadMsg",false);
                    };
                }.bind(this),3000);
            // });
        },
        cf_ShareDeviceP2P:function(port){
            if(port-0 === 0 && this.pro === 'http://'){
                this.socket.set.send(this.jsonStr(116,[this.wkAs.id,1,'1']));//非IE浏览器端口穿透
                this.pro='https://';
                return false;
            }else if(port-0 !== 0 && this.pro === 'http://'){
                var content = '<?xml version="1.0" encoding="utf-8"?>' +
                    '<envelope>' +
                    '<header>' +
                    '<security>username</security>' +
                    '<username>adminapp</username>' +
                    '<password>' +this.pwd+ '</password>' +
                    '</header>' +
                    '<body>' +
                    '<command>get.system.login</command>' +
                    '<content></content>' +
                    '</body>' +
                    '</envelope>';
                this.IPPort=port-0;
                this.contP=content;
                this.socketObj.set[133]=function(res){
                    this.cf_ShareDeviceP2Ps(res[0]);
                }.bind(this);
                this.socket.set.send(this.jsonStr(133,[this.pro+"127.0.0.1:" + port + "/tdkcgi",content]));
                return false;
            };
            this.cf_ShareDeviceP2PJump(port);
        },
        cf_ShareDeviceP2Ps:function(status){
            if (status === 'error'&&this.pro==='http://'){
                this.socket.set.send(this.jsonStr(116,[this.wkAs.id,1,'1']));//非IE浏览器端口穿透
                this.pro='https://';
                return false;
            };
            this.cf_ShareDeviceP2PJump(this.IPPort);
        },
        cf_ShareDeviceP2PJump:function(port){
            this.$emit("loadMsg",false);
            if(port-0===0){
                alert(this.lanNow.lan['K174_Fail']);
                this.$emit('refresh');
            }else{
                var deviceUserName='adminapp';
                var baseFun=this.base64;
                var base=new baseFun();
                var user=base.encode(deviceUserName);
                var pwd=base.encode(this.wkAs.pwd);
                var url = this.pro+"127.0.0.1:" + port + "/main.html" + "?" + port + "&" + this.wkAs.id +
                    "&" + user + "&" + pwd + "&" + localStorage.getItem('lan')+'&'+this.wkAs.name;
                window.open(url);
            }
        },
        cf_ShareDeviceP2PHs:function(port){
            if (port-0 <= 0){
                alert(this.lanNow.lan['K174_Fail']);
                this.$emit("loadMsg",false);
                this.$emit('refresh');
                return false;
            };
            var content = '<?xml version="1.0" encoding="utf-8"?>' +
                '<envelope>' +
                '<header>' +
                '<security>username</security>' +
                '<username>' +JSON.parse(this.wkAs.pwd).user+ '</username>' +
                '<password>' +JSON.parse(this.wkAs.pwd).pwd+ '</password>' +
                '</header>' +
                '<body>' +
                '<command>get.system.login</command>' +
                '<content></content>' +
                '</body>' +
                '</envelope>';
            this.IPPort=port-0;
            this.contP=content;
            this.socketObj.set[133]=function(res){
                this.cf_ShareDeviceP2PHsC(res[0]);
            }.bind(this);
            this.socket.set.send(this.jsonStr(133,[this.pro+"127.0.0.1:" + port + "/tdkcgi",content]));
        },
        cf_ShareDeviceP2PHsC:function(status){
            if (status === 'error'&&this.pro==='http://'){
                this.pro='https://';
                this.socket.set.send(this.jsonStr(133,[this.pro+"127.0.0.1:" + this.IPPort + "/tdkcgi",this.contP]));
            }else if(status === 'error'&&this.pro==='https://'){
                this.$emit("loadMsg",false);
            }else{
                this.$emit("loadMsg",false);
                var deviceUserName=JSON.parse(this.wkAs.pwd).user;
                var baseFun=this.base64;
                var base=new baseFun();
                var user=base.encode(deviceUserName);
                var pwd=base.encode(JSON.parse(this.wkAs.pwd).pwd);
                var url = this.pro+"127.0.0.1:" + this.IPPort + "/main.html" + "?" + this.IPPort + "&" + this.wkAs.id +
                    "&" + user + "&" + pwd + "&" + localStorage.getItem('lan')+'&'+this.wkAs.name;
                window.open(url);
            };
        },
        getPage:function(data){
            this.nowPage=data-0;
            this.setList=this.shareDevice[this.nowPage-1];
        },
        lang:function(){
            this.sCText=this.lanNow.lan['K038_ShareDevices'];
            this.title=[
                //{text:this.lanNow.lan['K023_DeviceName'],class:'title-2'},
                //{text:this.lanNow.lan['K004_CloudID'],class:'title-3'},
                //{text:this.lanNow.lan['K031_DeviceIP'],class:'title-3'},

                {text:this.lanNow.lan['K023_DeviceName'],class:'title-2'},
                {text:this.lanNow.lan['K004_CloudID'],class:'title-3'},
                {text:this.lanNow.lan['K031_DeviceIP'],class:'title-3'},

                {text:this.lanNow.lan['K039_DeviceOwner'],class:'title-2'},
                {text:this.lanNow.lan['K040_ValidTerm'],class:'title-4'},
                {text:this.lanNow.lan['K154_SharePower'],class:'title-4'},
                {text:this.lanNow.lan['K033_Status'],class:'title-1'},
                {text:this.lanNow.lan['K036_DeviceAccess'],class:'title-1'},
                {text:this.lanNow.lan['K035_ModifyDevice'],class:'title-1'},
                {text:this.lanNow.lan['K180_Status'],class:'title-1'}
            ];
        }
    },
    watch:{
        shareDevice:function(){
            var arr=JSON.parse(JSON.stringify(this.shareDevice));
            if(this.nowPage>arr.length&&arr.length>=1){
                this.setList=arr[arr.length-1];
                this.nowPage=arr.length;
            }else{
                this.setList=arr[this.nowPage-1];
            };
            this.allPage=arr.length;
        }
    }
}
</script>
<style scoped>
    #shareCloud{
        width:100%;
        /* height:230px; */
    }
    #scTitle{
        font-size:14px;
        font-weight: bold;
        color:#229EF1;
        padding-left:10px;
        box-sizing: border-box;
    }
    #scTable{
        width:100%;
    }
    #scTable ul{
        width:100%;
        height:24px;
    }
    #scTable ul li{
        height:24px;
        font-size:12px;
        line-height:24px;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        box-sizing: border-box;
    }
    #scTable ul li+li{
        border-left:1px solid #BFC7D2;
    }
    #scTable ul:nth-child(n+1) li{
        border-top:1px solid #BFC7D2;
    }
    #scTh{
        background-color: #7F8B9B;
    }
    #scTh li{
        color:#fff;
        font-weight: bold;
    }
    #scTable ul+ul{
        background-color: #FFFFFF;
    }
    #scTable ul+ul li{
        color:#000;
    }
    .title-1{
        width:9%;
    }
    .title-2{
        width:10%;
    }
    .title-3{
        width:12%;
    }
    .title-4{
        width:16%;
    }
    .title-5{
        width:32%;
    }
</style>
<style scoped>
    @import '../assets/css/tabList.css';  
</style>





// WEBPACK FOOTER //
// src/components/ShareDevice.vue